<template>
  <div class="video-review-questions">
    <MicroAnimation
      v-if="!empty && videoDetail.video_url"
      :from="from"
      @submitEnd="submitEnd"
      @changeType="changeType"
      :videoSrc="videoDetail.video_url"
      :videoPoster="videoDetail.video_coverimg"
    ></MicroAnimation>
    <div class="empty" v-else>
      <div class="empty-icon"></div>
      <p>{{$t('blendType.noLove')}}</p>
    </div>
    <pop-tips
      @handConfirm="handConfirm"
      @handleCloseTip="handleCloseTip"
      :dialogVisable="dialogVisable"
      :popTipsCont="popTipsCont"
    ></pop-tips>
  </div>
</template>
<script>
import MicroAnimation from "@/components/StudyCenter/Review/MicroAnimation"; // 微动画
import PopTips from "@/components/popTips";
import VideoHttp from "../video";
export default {
  name: "video-review-questions",
  data() {
    return {
      from: "",
      videoDetail: {
        video_url: "",
        video_coverimg: ""
      },
      empty: false,
      dialogVisable: false,
      popTipsCont: {
        title: "恭喜获得奖励",
        context: `<span class="gold"></span> +4`,
        btns: [
          {
            text: "确定",
            event: "handConfirm"
          }
        ]
      }
    };
  },
  components: {
    MicroAnimation,
    PopTips
  },
  created() {
    this.$store.dispatch("setLoadingStatus", true);
    this.$emit("changeFromType", "detail");
    this.id = this.$route.query.id;
    this.from = this.$route.query.from;
    this.student_id = this.$store.state.currentChild.student_id;
    this.getOneVideo(this.id);
    this.like();
  },
  methods: {
    submitEnd(v) {
      console.log(v);
      if (v == "video") {
        console.log("video");
      }
    },
    bakToPrev() {
      // this.$router.push({ path: "/StudyCenter" });
      console.log("bakToPrev");
    },
    getData() {
      console.log("getData");
    },
    changeType(v) {
      console.log(v);
      this.type = v;
    },
    submitOk() {
      this.dialogVisable = true;
    },
    handleCloseTip() {
      this.dialogVisable = false;
    },
    handConfirm() {
      console.log("ok");
    },

    getOneVideo(video_id) {
      VideoHttp.getOneVideo({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        video_id
      }).then(res => {
        console.log(res);
        const { error, result } = res.data;
        if (error) {
          this.videoDetail = result.list;
        } else {
          this.empty = true;
        }
        this.$emit("changeFromTitle", this.videoDetail.video_title);
        this.$store.dispatch("setLoadingStatus", false);
      });
    },

    // 获取 单个图书 喜欢 状态
    like() {
      VideoHttp.like({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        video_id: this.id
      }).then(res => {
        this.isLove = res.data.result.list == 0 ? false : true;
        this.$emit("emitChangeLove", this.isLove);
      });
    },
    changeLike() {
      VideoHttp.changeLike({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        video_id: this.id,
        is_like: this.isLove ? 1 : 0
      }).then(res => {
        this.like();
      });
    }
  }
};
</script>
<style lang="less">
.video-review-questions {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .empty-icon {
      width: 119px;
      height: 156px;
      background: url(../../../../assets/images/studyCenter/empty-icon.png)
        center center no-repeat;
      background-size: 100% 100%;
    }
    p {
      margin-top: 15px;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
      line-height: 20px;
    }
  }
}
</style>